import { Icon } from "@chakra-ui/react";
const PolandIcon = () => {
  return (
    <>
      <Icon width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 5H0V0H6.66667V5Z" fill="white" />
        <path fillRule="evenodd" clipRule="evenodd" d="M6.66667 5H0V2.5H6.66667V5Z" fill="#DC143C" />
      </Icon>
    </>
  );
};
export default PolandIcon;
